import { isNil } from 'lodash';

/**
 * Posts parameters through a hidden form in the current tab by default.
 * Use `_blank` to open a new tab without access to the opener window.
 */
export function formPost(
  path: string,
  params: Record<string, string | number | boolean>,
  target = '_self'
): void {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = path;
  form.target = target;
  form.rel = 'noopener';

  for (const key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      const hiddenField = document.createElement('input');
      hiddenField.type = 'hidden';
      hiddenField.name = key;

      const value = params[key]?.toString();
      if (!isNil(value)) {
        hiddenField.value = value;
      }

      form.appendChild(hiddenField);
    }
  }

  document.body.appendChild(form);
  form.submit();
  form.remove();
}
